var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{attrs:{"dark":"","fixed":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Användarvillkor")])],1),_c('terms-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }